import moment from 'moment';
import _ from 'lodash';

import {
  GET_WISHLIST_SUCCESS,
  GET_WISHLIST_FAIL,
  ADD_WISH_SUCCESS,
  UPDATE_WISH_SUCCESS,
  DELETE_WISH_SUCCESS,
  ADD_UPVOTE_WISH_SUCCESS,
  DELETE_UPVOTE_WISH_SUCCESS,
  ADD_WISH_DETAIL,
  REMOVE_WISH_DETAIL,
  CHANGE_ORDER_TYPE,
  GET_WISH_DETAIL_SUCCESS
} from "../actions/wishs";

import { USER_LOGOUT } from "../actions/auth";

// const initialState = {
//   wishs: [],
//   wishDetails: [],
//   error: null
// };

const initialState = {};

const WishlistReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_WISHLIST_SUCCESS:
      return {
        ...state,
        wishs: action.wishs,
        error: null
      };
    case GET_WISHLIST_FAIL:
      return {
        ...state,
        wishs: [],
        error: action.error
      };
    case ADD_WISH_SUCCESS: {
      return {
        ...state,
        wishs: [
          ...state.wishs,
          action.wish
        ],
        error: null
      }
    }
    case UPDATE_WISH_SUCCESS: {
      const wishs = state.wishs || [];
      const wishDetails = state.wishDetails || [];
      
      const findIndex = wishs.findIndex(wish => wish.id === action.wish.id);
      const findDetailIndex = wishDetails.findIndex(wish => wish.id === action.wish.id);

      if (findDetailIndex >= 0) {
        wishDetails[findDetailIndex] = {
          ...action.wish
        }
      }

      if (findIndex >= 0) {
        wishs[findIndex] = {
          ...action.wish
        };
      }

      return {
        ...state,
        wishs: [
          ...wishs
        ],
        wishDetails: [
          ...(wishDetails || [])
        ],
        error: null
      }
    }
    case DELETE_WISH_SUCCESS: {
      const wishs = (state.wishs || []).filter(wish => wish.id !== action.id);

      return {
        ...state,
        wishs: [
          ...wishs
        ],
        error: null
      };
    }
    case ADD_UPVOTE_WISH_SUCCESS: {
      const wishs = state.wishs || [];
      const findIndex = wishs.findIndex(wish => wish.id === action.wish.id);
      wishs[findIndex] = action.wish;

      return {
        ...state,
        wishs: [
          ...wishs
        ],
        error: null
      };
    }
    case DELETE_UPVOTE_WISH_SUCCESS: {
      const wishs = state.wishs || [];
      const findIndex = wishs.findIndex(wish => wish.id === action.wish.id);
      wishs[findIndex] = action.wish;

      return {
        ...state,
        wishs: [
          ...wishs
        ],
        error: null
      };
    }
    case ADD_WISH_DETAIL: {
      const wishs = state.wishs || [];
      const wishDetails = state.wishDetails || [];
      const wishDetail = wishs.find(wish => wish.id === action.id);
      const findDetailIndex = wishDetails.findIndex(wish => wish.id === action.id);
      if (findDetailIndex < 0 && wishDetail) {
        wishDetails.push(wishDetail);
      }

      return {
        ...state,
        wishDetails: [ ...wishDetails ]
      }
    }
    case GET_WISH_DETAIL_SUCCESS: {
      const wishs = state.wishs || [];
      const wishDetails = state.wishDetails || [];
      const wishDetail = wishs.find(wish => wish.id === action.id);
      const findDetailIndex = wishDetails.findIndex(wish => wish.id === action.id);
      if (findDetailIndex < 0) {
        wishDetails.push(action.wishDetail);
      }

      if (!wishDetail) {
        wishs[findDetailIndex] = action.wishDetail;
      }

      return {
        ...state,
        wishDetails: [ ...wishDetails ],
        wishs: [ ...wishs ]
      }
    }
    case REMOVE_WISH_DETAIL: {
      let wishDetails = state.wishDetails || [];
      wishDetails = wishDetails.filter(wish => wish.id !== action.id);

      return {
        ...state,
        wishDetails: [ ...(wishDetails || []) ]
      }
    }
    case CHANGE_ORDER_TYPE: {
      let wishs = state.wishs || [];

      switch (action.orderType) {
        case 1:
          wishs = wishs.sort((w1, w2) => {
            const c1 = _.get(w1, 'upvoteCount', 0);
            const c2 = _.get(w2, 'upvoteCount', 0);
            if (c1 < c2) {
              return 1;
            } else if (c1 === c2) {
              return 0;
            } else {
              return -1;
            }
          });
          break;
        case 2:
          wishs = wishs.sort((w1, w2) => {
            if (moment(w1.createdAt) < moment(w2.createdAt)) {
              return 1;
            } else if (moment(w1.createdAt) === moment(w2.createdAt)) {
              return 0;
            } else {
              return -1;
            }
          });
          break;
        case 3:
          wishs = wishs.sort((w1, w2) => {
            if (moment(w1.createdAt) > moment(w2.createdAt)) {
              return 1;
            } else if (moment(w1.createdAt) === moment(w2.createdAt)) {
              return 0;
            } else {
              return -1;
            }
          });
          break;
        default:
          break;
      }

      return {
        ...state,
        wishs: [ ...wishs ]
      };
    }
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
}

export default WishlistReducer;
